import { Header } from "./Header";
import styles from "./styles.module.css";
import { customAlphabet } from "nanoid";
import * as producers from "./producers";
import { EnvelopesDashboard } from "./EnvelopesDashboard";
import { Loader } from "./components/layout/Loader";
import { AppVersion } from "./components/version";

const nanoid = customAlphabet(
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_",
  15
);

export const App: view = ({ appIsReady = observe.isReady.languages, langId = observe.langId }) => {
  const componentId = nanoid();
  return (
    <div className={styles.app}>
      {appIsReady ? (
        <>
          <Header componentId={componentId} langId={langId} />
          <EnvelopesDashboard />
        </>
      ) : (
        <Loader />
      )}
      <AppVersion />
    </div>
  );
}

App.producers(Object.values(producers));
